import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { AuthLayout } from "@/features/auth/modules/auth-layout/auth-layout";
import { ConfirmEmailForm } from "@/features/auth/modules/confirm-email/confirm-email-form";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/verify-email/")({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: m.auth_verify_email_crumb(),
    };
  },
  validateSearch: z.object({
    email: z.string().optional(),
    userId: z.string().optional(),
  }),
});

function RouteComponent() {
  const { email, userId } = Route.useSearch();

  return (
    <AuthLayout>
      <ConfirmEmailForm userId={userId} email={email} />
    </AuthLayout>
  );
}
